import { render, staticRenderFns } from "./ApprTemp3.vue?vue&type=template&id=79f65648&scoped=true&"
import script from "./ApprTemp3.vue?vue&type=script&lang=js&"
export * from "./ApprTemp3.vue?vue&type=script&lang=js&"
import style0 from "./ApprTemp3.vue?vue&type=style&index=0&id=79f65648&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f65648",
  null
  
)

export default component.exports